/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_169_TitleInputs */

const en_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12th Anniversary Cake Tree`)
};

const ar_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الذكرى السنوية الثانية عشر لشجرة الكيك`)
};

const de_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tortenbaum zum 12. Jahrestag`)
};

const es_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árbol de pastel del 12º cumpleaños`)
};

const fr_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbre Gâteau du 12e anniversaire`)
};

const it_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Albero Torta del 12° Anniversario`)
};

const ja_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12周年記念ケーキの木`)
};

const ko_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12주년 기념 케이크 나무`)
};

const pt_br_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árvore Bolo de 12º Aniversário`)
};

const ru_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Торт-дерево на 12-ю годовщину`)
};

const th_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นเค้กฉลองครบรอบ 12 ปี`)
};

const tr_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Yıl Dönümü Pasta Ağacı`)
};

const zh_cn_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`十二周年蛋糕树`)
};

const zh_tw_tree_type_169_title = /** @type {(inputs: Tree_Type_169_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`十二週年蛋糕樹`)
};

/**
* | output |
* | --- |
* | "12th Anniversary Cake Tree" |
*
* @param {Tree_Type_169_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_169_title = /** @type {((inputs?: Tree_Type_169_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_169_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_169_title(inputs)
	if (locale === "ar") return ar_tree_type_169_title(inputs)
	if (locale === "de") return de_tree_type_169_title(inputs)
	if (locale === "es") return es_tree_type_169_title(inputs)
	if (locale === "fr") return fr_tree_type_169_title(inputs)
	if (locale === "it") return it_tree_type_169_title(inputs)
	if (locale === "ja") return ja_tree_type_169_title(inputs)
	if (locale === "ko") return ko_tree_type_169_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_169_title(inputs)
	if (locale === "ru") return ru_tree_type_169_title(inputs)
	if (locale === "th") return th_tree_type_169_title(inputs)
	if (locale === "tr") return tr_tree_type_169_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_169_title(inputs)
	return zh_tw_tree_type_169_title(inputs)
});